import {ScreenUtil} from "./ScreenUtil";

export const util = {
  screen : new ScreenUtil(),
};
